import React, { useEffect } from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { useNavigate } from "react-router-dom";

import Device from "Components/Shared/Device/Device";

import { useSelector } from "react-redux";

interface props {
	siteData: any;
}

const SiteRow: React.FC<props> = ({ siteData }) => {
	const state = useSelector((state: any) => state.homeState);
	const redirect = useNavigate();
	const handleUrl = (deviceID: number) => {
		redirect(`/device/${deviceID}`);
	};
	useEffect(() => {
		const observer = new ResizeObserver((entries) => {
			requestAnimationFrame(() => {
				for (let entry of entries) {
					// safely trigger any updates
					// avoid state changes directly in this block if possible
				}
			});
		});

		observer.observe(document.body); // or any element
		return () => observer.disconnect();
	}, []);
	return (
		<Row className="gauge-row">
			<h6 style={{ padding: 0, margin: "0 8px" }}>{siteData[0]}</h6>
			{siteData[1].length > 0
				? siteData[1]
						.sort((a: any, b: any) => (a.name > b.name ? 1 : -1))
						.sort(function (a: any, b: any) {
							return a.name - b.name;
						})
						.map((device: any) => (
							<Col
								onClick={() => handleUrl(device.deviceId)}
								xs={4}
								md={2}
								key={device.deviceId}
								style={{ padding: "5px" }}
							>
								<Device
									device={device}
									state={""}
									graph={state.view === 1 ? true : false}
									show={true}
									myGraph={true}
									page="home"
								/>
							</Col>
						))
				: null}
		</Row>
	);
};

export default SiteRow;
